import React, { useEffect } from 'react';
import { func, object, string } from 'prop-types';
import { connect } from 'react-redux';

import {
  PERSONAL,
  COMPANY,
  DONATION,
} from '@dragonfruit/constants/eInvoiceTypes';

import { getUserEmail } from '@dragonfruit/redux/profile';
import TabSelect from '@dragonfruit/components/TabSelect';
import Checkbox from '@dragonfruit/components/fields/Checkbox';

import Personal from './components/Personal';
import Company from './components/Company';
import Donation from './components/Donation';

import styles from './EInvoiceSelector.scss';

const EInvoiceSelector = ({
  initialValues,
  onFieldChange,
  setFieldListValue,
  setFieldErrorListValue,
  validateFields,
  errors,
  accountEmail,
  t,
}) => {
  const eInvoiceTypeList = [
    {
      value: PERSONAL,
      label: t('purchase.tweinvoice.type.duplicate'),
    },
    {
      value: COMPANY,
      label: t('purchase.tweinvoice.type.triplicate'),
    },
    {
      value: DONATION,
      label: t('purchase.tweinvoice.type.donate'),
    },
  ];

  const {
    category,
    autoBroughtIn,
    personalEmail,
    companyEmail,
    companyName,
    phoneBarcode,
    guiNumber,
    loveCode,
    unconfirmedEmail,
    personalEmailSameAsAccountEmail,
    companyEmailSameAsAccountEmail,
  } = initialValues;

  const onSelectType = selectedType => onFieldChange('category', selectedType);

  const typeComponents = {
    [PERSONAL]: (
      <Personal
        initialValues={{
          personalEmail,
          phoneBarcode,
          personalEmailSameAsAccountEmail,
        }}
        errors={errors}
        onFieldChange={onFieldChange}
        accountEmail={accountEmail}
      />
    ),
    [COMPANY]: (
      <Company
        initialValues={{
          companyEmail,
          guiNumber,
          companyName,
          companyEmailSameAsAccountEmail,
        }}
        errors={errors}
        onFieldChange={onFieldChange}
        accountEmail={accountEmail}
      />
    ),
    [DONATION]: (
      <Donation
        initialValues={{ loveCode }}
        errors={errors}
        onFieldChange={onFieldChange}
      />
    ),
  };

  useEffect(() => {
    if (!personalEmailSameAsAccountEmail && !companyEmailSameAsAccountEmail) {
      return;
    }

    setFieldListValue({
      ...(personalEmailSameAsAccountEmail && {
        personalEmail: unconfirmedEmail || accountEmail,
      }),
      ...(companyEmailSameAsAccountEmail && {
        companyEmail: unconfirmedEmail || accountEmail,
      }),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    unconfirmedEmail,
    personalEmailSameAsAccountEmail,
    companyEmailSameAsAccountEmail,
  ]);

  useEffect(() => {
    if (personalEmailSameAsAccountEmail) {
      setFieldErrorListValue({ personalEmail: '' });
      return;
    }

    if (personalEmail && !personalEmailSameAsAccountEmail) {
      validateFields(['personalEmail']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalEmailSameAsAccountEmail]);

  useEffect(() => {
    if (companyEmailSameAsAccountEmail) {
      setFieldErrorListValue({ companyEmail: '' });
      return;
    }

    if (companyEmail && !companyEmailSameAsAccountEmail) {
      validateFields(['companyEmail']);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyEmailSameAsAccountEmail]);

  return (
    <div>
      <h4 className={styles.title}>{t('purchase.tweinvoice.title')}</h4>
      <TabSelect
        options={eInvoiceTypeList}
        value={category}
        onChange={onSelectType}
      />
      <div>{typeComponents[category]}</div>
      <Checkbox
        label={t('purchase.tweinvoice.autofill')}
        checked={autoBroughtIn}
        onChange={value => onFieldChange('autoBroughtIn', value)}
      />
    </div>
  );
};

EInvoiceSelector.propTypes = {
  errors: object.isRequired,
  initialValues: object.isRequired,
  setFieldErrorListValue: func.isRequired,
  setFieldListValue: func.isRequired,
  t: func.isRequired,
  validateFields: func.isRequired,
  onFieldChange: func.isRequired,
  accountEmail: string,
};

EInvoiceSelector.defaultProps = {
  accountEmail: '',
};

export default connect(state => ({
  accountEmail: getUserEmail(state),
}))(EInvoiceSelector);



// WEBPACK FOOTER //
// ./app/components/EInvoiceSelector/EInvoiceSelector.jsx